export const SET_PRODUCT_CART = 'content/SET_PRODUCT_CART';
export const GET_PRODUCT_CART = 'content/GET_PRODUCT_CART';
export const UPDATE_PRODUCT_CART = 'content/UPDATE_PRODUCT_CART';
export const GET_SHOP_STATUS = 'content/GET_SHOP_STATUS';
export const UPDATE_SHOP_STATUS = 'content/UPDATE_SHOP_STATUS';
